const PageFind = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.5 4.5A1.5 1.5 0 0 0 6 6v12a1.5 1.5 0 0 0 1.5 1.5h9A1.5 1.5 0 0 0 18 18V9.5h-2.5A2.5 2.5 0 0 1 13 7V4.5zM5 6a2.5 2.5 0 0 1 2.5-2.5h6a.5.5 0 0 1 .354.146l5 5A.5.5 0 0 1 19 9v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 5 18z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M11.423 16.846a3.3 3.3 0 0 1-2.418-1.005A3.3 3.3 0 0 1 8 13.424q0-1.413 1.005-2.418A3.3 3.3 0 0 1 11.423 10q1.414 0 2.419 1.005a3.3 3.3 0 0 1 1.004 2.418q0 .555-.159 1.087a2.9 2.9 0 0 1-.502.967l2.192 2.192a.5.5 0 0 1 .15.345.47.47 0 0 1-.15.363.46.46 0 0 1-.354.15.57.57 0 0 1-.354-.15l-2.192-2.173a4.6 4.6 0 0 1-.973.464 3.3 3.3 0 0 1-1.08.178m-.004-1a2.35 2.35 0 0 0 1.721-.701q.706-.702.706-1.717a2.35 2.35 0 0 0-.701-1.722A2.33 2.33 0 0 0 11.428 11a2.35 2.35 0 0 0-1.722.701A2.33 2.33 0 0 0 9 13.42q0 1.016.701 1.721t1.718.706"
    />
  </>
)
export default PageFind
